<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST" role="form">

      <div v-if="deleting">
          <p>Are you sure you want to delete this automatic response text?</p>
      </div>
      <div v-else>

        <div class="form-group row">
          <label for="text" class="col-sm-2 col-form-label">Text:</label>
          <div class="col-sm-10">
            <textarea name="text" class="form-control" required="required" rows="3" v-model="text"></textarea>
            <div v-if="campaignCount" class="text-warning">
              Please note that this response text is already used in some text campaigns and by changing it, you change the automatic response settings for all campaigns.
            </div>
          </div>
        </div>

      </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <template v-if="deleting">
        <button type="button" class="btn btn-default" @click.prevent="cancelDeletion"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting" @click.prevent="confirmDeletion"><i class="fa fa-fw fa-trash"></i> Delete</button>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="submit" class="btn btn-primary" :form="formId" :disabled="isEmpty"><i class="fa fa-fw fa-save"></i> Save changes</button>
      </template>
    </template>
  </modal>
</template>

<script>
import HasModal from "../../mixins/HasModal";

export default {
  mixins: [HasModal],

  props: {
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'responses-modal'
    },

    initialText: {
      type: String,
      default: ''
    },

    id: {
      type: Number,
      default: 0
    },

    action: {
      type: String,
      required: true
    },

    campaignCount: {
      type: Number,
      default: 0
    },
  },

  data() {
    return {
      text: this.initialText,
      deleting: false,
    }
  },

  computed: {
    formId() {
      return this.modalId + '-form';
    },
    title() {
      if (this.deleting) return 'Delete text';
      return this.isNew ? "Add a text" : "Edit text";
    },
    method() {
      if (this.deleting) return 'DELETE';
      return this.isNew ? "POST" : "PATCH";
    },
    hasData() {
      return !!(this.text && this.text.trim().length);
    },
    isEmpty() {
      return !this.hasData;
    },
    isExisting() {
      return this.id > 0;
    },
    isNew() {
      return !this.isExisting;
    }
  },

  methods: {
    confirmDeletion() {
      this.deleting = true;
    },
    cancelDeletion() {
      this.deleting = false;
    },
  }
}

</script>
